// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3xAPM","col":"styles_col__2Qlwn","fulfillmentStatus":"styles_fulfillmentStatus__3mIpR","emailCol":"styles_emailCol__2QTS9"};